var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EmployeeLink',{attrs:{"user":_vm.value}}),(_vm.canRemove)?_c('i',{staticClass:"fas fa-times text-danger ml-2",on:{"click":function($event){return _vm.$emit("remove", _vm.value)}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }